import React, { useEffect } from "react";
import Prism from "prismjs";
import { BlogContentWrappper } from "./style";
import { RichText } from "./../../styles/richText";
import PropTypes from "prop-types";

const BlogContent = ({ contentInHtml }) => {
	useEffect(() => {
		Prism.highlightAll();
	});

	return (
		<BlogContentWrappper className="BlogContent">
			<RichText>
				<div
					className="rich-text-wrapper"
					dangerouslySetInnerHTML={{ __html: contentInHtml }}
				></div>
			</RichText>
		</BlogContentWrappper>
	);
};

BlogContent.propTypes = {
	contentInHtml: PropTypes.string.isRequired,
};

export default BlogContent;
